import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import { useTheme } from '../../contexts/ThemeContext';
import { useLanguage } from '../../hooks/useLanguage';
import { useGetUserProfileQuery } from '../../store/api/userApi';
import { useGetHideProductsStatusQuery } from '../../store/api/catalogApi';

const DashboardIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
  </svg>
);
const ProfileIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
  </svg>
);
const BalanceIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);
const RechargeIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
  </svg>
);
const TransactionsIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
  </svg>
);
const CatalogIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
  </svg>
);
const PurchasesIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
  </svg>
);
const TemporaryNumbersIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
  </svg>
);
const PermanentNumbersIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
  </svg>
);
const ProxiesIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
  </svg>
);
const TicketIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 5v2m0 4v2m0 4v2M5 19a2 2 0 01-2-2V5a2 2 0 012-2h3.172a2 2 0 011.414.586l1.414 1.414A2 2 0 0012.828 5H19a2 2 0 012 2v12a2 2 0 01-2 2H5z" />
  </svg>
);
const SupportIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.446 1.394c-.14.18-.357.295-.6.295-.002 0-.003 0-.005 0l.213-3.054 5.56-5.022c.24-.213-.054-.334-.373-.12l-6.87 4.326-2.96-.924c-.64-.203-.658-.64.135-.954l11.566-4.458c.538-.196 1.006.128.832.941z" />
  </svg>
);
const ApiDocsIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
  </svg>
);
const SiteServicesIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
  </svg>
);
const RocketSaasIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
  </svg>
);
const AdminIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);
const SupportAdminIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
  </svg>
);
const CloseIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
  </svg>
);

type NavItem = {
  path: string;
  icon: () => React.ReactElement;
  translationKey: string;
  external?: boolean;
};

const MAIN_ITEMS: NavItem[] = [
  { path: '/dashboard', icon: DashboardIcon, translationKey: 'dashboard' },
  { path: '/temporary-numbers', icon: TemporaryNumbersIcon, translationKey: 'temporaryNumbers' },
  { path: '/permanent-numbers', icon: PermanentNumbersIcon, translationKey: 'permanentNumbers' },
  { path: '/proxies', icon: ProxiesIcon, translationKey: 'proxies' },
  { path: '/catalog', icon: CatalogIcon, translationKey: 'catalog' },
  { path: '/purchases', icon: PurchasesIcon, translationKey: 'purchases' },
];

const ACCOUNT_ITEMS: NavItem[] = [
  { path: '/profile', icon: ProfileIcon, translationKey: 'profile' },
  { path: '/balance', icon: BalanceIcon, translationKey: 'balance' },
  { path: '/recharge', icon: RechargeIcon, translationKey: 'recharge' },
  { path: '/transactions', icon: TransactionsIcon, translationKey: 'transactions' },
  { path: '/tickets', icon: TicketIcon, translationKey: 'tickets' },
];

const SUPPORT_ITEMS: NavItem[] = [
  { path: '/support', icon: SupportIcon, translationKey: 'support' },
  { path: '/api-docs.html', icon: ApiDocsIcon, translationKey: 'apiDocs', external: true },
  { path: 'https://blog.rocketproxy.io/services', icon: SiteServicesIcon, translationKey: 'siteServices', external: true },
  { path: '/rocket-saas', icon: RocketSaasIcon, translationKey: 'requestRocketSaas' },
];

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

export function Sidebar({ isOpen, onClose }: SidebarProps) {
  const { t, i18n } = useTranslation();
  const { theme } = useTheme();
  const { isRTL } = useLanguage();
  const location = useLocation();
  const [isDesktop, setIsDesktop] = useState(false);

  const { data: userData } = useGetUserProfileQuery();
  const { data: hideProductsData } = useGetHideProductsStatusQuery();
  const isProductsHidden = hideProductsData?.data?.hideProducts?.website === true;
  const isAdmin = userData?.data.user.isAdmin || false;
  const isSupportAdmin = userData?.data.user.role === 'admin_support' || isAdmin;
  const userName = userData?.data.user.firstName || userData?.data.user.email || 'User';

  useEffect(() => {
    const checkDesktop = () => setIsDesktop(window.innerWidth >= 1024);
    checkDesktop();
    window.addEventListener('resize', checkDesktop);
    return () => window.removeEventListener('resize', checkDesktop);
  }, []);

  const filterItems = (items: NavItem[]) =>
    items.filter((item) => !((item.path === '/catalog' || item.path === '/purchases') && isProductsHidden));

  const isActive = (path: string) =>
    location.pathname === path || (path !== '/dashboard' && location.pathname.startsWith(path));

  const linkClass = (active: boolean) =>
    active
      ? 'dx-nav-link is-active'
      : 'dx-nav-link';

  const renderItem = (item: NavItem) => {
    const Icon = item.icon;
    const active = isActive(item.path);
    const onNav = () => {
      if (!isDesktop) onClose();
    };

    if (item.external) {
      return (
        <li key={item.path}>
          <a
            href={`${item.path}?lang=${i18n.language || 'ar'}`}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onNav}
            className={linkClass(false)}
          >
            <Icon />
            <span>{t(`navigation.${item.translationKey}`)}</span>
          </a>
        </li>
      );
    }

    return (
      <li key={item.path}>
        <Link
          to={item.path}
          onClick={onNav}
          className={linkClass(active)}
          aria-current={active ? 'page' : undefined}
        >
          <Icon />
          <span>{t(`navigation.${item.translationKey}`)}</span>
        </Link>
      </li>
    );
  };

  const renderGroup = (label: string, items: NavItem[]) => {
    const list = filterItems(items);
    if (!list.length) return null;
    return (
      <div className="dx-nav-group">
        <div className="dx-sidebar__label">{label}</div>
        <ul>{list.map(renderItem)}</ul>
      </div>
    );
  };

  return (
    <>
      {isOpen && !isDesktop && (
        <div className="dx-sidebar-overlay" onClick={onClose} aria-hidden="true" />
      )}

      <aside
        className={`app-sidebar dx-sidebar ${isRTL ? 'is-rtl' : 'is-ltr'} ${
          isOpen ? 'is-open' : 'is-closed'
        } ${isDesktop ? 'is-desktop' : 'is-mobile'} ${theme === 'light' ? 'is-light' : 'is-dark'}`}
        role="navigation"
        aria-label="Main navigation"
        {...(!isOpen && !isDesktop ? { inert: 'true' } : {})}
      >
        <div className="dx-sidebar__head">
          <div className="dx-sidebar__user">
            <span className="dx-sidebar__avatar">{String(userName).slice(0, 1).toUpperCase()}</span>
            <div>
              <strong>{userName}</strong>
              <small>{t('navigation.dashboard', { defaultValue: 'Dashboard' })}</small>
            </div>
          </div>
          <button
            type="button"
            className="dx-sidebar__close"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onClose();
            }}
            aria-label={t('navigation.closeMenu')}
          >
            <CloseIcon />
          </button>
        </div>

        <nav className="dx-sidebar__nav">
          {renderGroup(t('home.nav.services', { defaultValue: 'Services' }), MAIN_ITEMS)}
          {renderGroup(t('navigation.profile', { defaultValue: 'Account' }), ACCOUNT_ITEMS)}
          {renderGroup(t('navigation.support', { defaultValue: 'Support' }), SUPPORT_ITEMS)}

          {isAdmin && (
            <div className="dx-nav-group">
              <div className="dx-sidebar__label">{t('navigation.admin')}</div>
              <ul>
                <li>
                  <Link
                    to="/admin/dashboard"
                    onClick={() => { if (!isDesktop) onClose(); }}
                    className={linkClass(location.pathname.startsWith('/admin'))}
                    aria-current={location.pathname.startsWith('/admin') ? 'page' : undefined}
                  >
                    <AdminIcon />
                    <span>{t('navigation.adminDashboard')}</span>
                  </Link>
                </li>
              </ul>
            </div>
          )}

          {isSupportAdmin && (
            <div className="dx-nav-group">
              <div className="dx-sidebar__label">{t('navigation.supportAdmin')}</div>
              <ul>
                <li>
                  <Link
                    to="/support"
                    onClick={() => { if (!isDesktop) onClose(); }}
                    className={linkClass(location.pathname.startsWith('/support'))}
                    aria-current={location.pathname.startsWith('/support') ? 'page' : undefined}
                  >
                    <SupportAdminIcon />
                    <span>{t('navigation.supportDashboard')}</span>
                  </Link>
                </li>
              </ul>
            </div>
          )}
        </nav>
      </aside>
    </>
  );
}
